import { JSON_SCHEMA_KEYWORDS, JSON_SCHEMA_SAFE_HTML_KEYWORDS } from '../constants';

// filter out any unsafe JSON Schema keywords
export default function computeUIProps(UIProps) {
  return Object.keys(UIProps)
    .filter(
      (keyword) =>
        !JSON_SCHEMA_KEYWORDS.includes(keyword) || JSON_SCHEMA_SAFE_HTML_KEYWORDS.includes(keyword)
    )
    .reduce(
      (prev, curr) => ({
        ...prev,
        [curr]: UIProps[curr],
      }),
      {}
    );
}
